import { createContext, useContext, useSyncExternalStore } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/slider/context.tsx
const SliderContext = createContext(null);
function SliderProvider({ value, children }) {
	return /* @__PURE__ */ jsx(SliderContext.Provider, {
		value,
		children
	});
}
function useSliderContext() {
	const ctx = useContext(SliderContext);
	if (!ctx) throw new Error("Slider compound components must be used within a Slider.Root");
	return ctx;
}
function useSliderPointerValue(enabled = true) {
	const context = useSliderContext();
	const percent = useSyncExternalStore((onChange) => context.input?.subscribe(onChange) ?? (() => {}), () => enabled ? context.input?.current.pointerPercent ?? null : null, () => enabled ? context.input?.current.pointerPercent ?? null : null);
	return percent === null ? context.pointerValue : context.getPointerValue?.(percent) ?? context.pointerValue;
}
//#endregion
export { SliderProvider, useSliderContext, useSliderPointerValue };

//# sourceMappingURL=context.js.map